import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Contact.css';

import white_arrow from '../assets/white-arrow.png';
import mhAcademyLogo from '../assets/logo2.1.png';
import contactImage from '../assets/contact-removebg-preview.png';

const Contact = () => {
  const [result, setResult] = useState("");

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");
    const formData = new FormData(event.target);

    formData.append("access_key", "320cb6a8-df16-4f9d-883f-bc97481f9ec1");

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    }).then((res) => res.json());

    setResult(res.message);
    if (res.success) event.target.reset();
  };

  return (
    <section className="contact-container" data-aos="fade-up">
      <h2 className="contact-title">Contact Us</h2>

      <div className="contact-card">
        
        {/* Left Image */}
        <div className="contact-image" data-aos="fade-right">
          <img src={contactImage} alt="Contact" />
        </div>

        {/* Right Form */}
        <div className="contact-form" data-aos="fade-left">
          <img className="form-logo" src={mhAcademyLogo} alt="MH Academy" />

          <form onSubmit={onSubmit}>
            <label>Your Name</label>
            <input type="text" name="name" placeholder="Enter your name" required />

            <label>Phone Number</label>
            <input type="tel" name="phone" placeholder="Enter your mobile number" required />

            <label>Your Message</label>
            <textarea name="message" rows="5" placeholder="Enter your message" required />

            <button type="submit" className="submit-btn">
              Submit Now <img src={white_arrow} alt="" />
            </button>
          </form>

          {result && <p className="form-result">{result}</p>}
        </div>

      </div>
    </section>
  );
};

export default Contact;
